import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanMatchFn, Route, Router, UrlTree } from '@angular/router';

import Urls from '../constants/urls';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagGuard implements CanActivate {
  constructor(private featureFlagService: FeatureFlagService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.featureFlagService.ensureLoaded().pipe(
      map((flags) =>
        flags[next.data.featureFlagKey]?.enabled ? true : this.router.createUrlTree([Urls.APP])
      )
    );
  }
}

export const featureFlagGuard: CanMatchFn = (route: Route) => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);

  return featureFlagService.ensureLoaded().pipe(
    map((flags) =>
      flags[route.data.featureFlagKey]?.enabled ? true : router.createUrlTree([Urls.APP])
    )
  );
};
